@import "src/helpers/ScreenSizes.scss"; //mixins for different screen sizes

.cardListScreen {
  @include windowSizes();
  border: 1px solid #c5c5ca;
  border-radius: 20px;
  background-color: white;
  overflow: auto;
}

.topParent {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @include small() {
    margin-top: 15px;
  }
}

@mixin topText() {
  font-family: "Inter";
  font-style: normal;
  text-align: center;
  font-feature-settings: "liga" off;
  color: #39393a;
}

.topTitle {
  @include topText();
  display: flex;

  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
}

.topSubTitle {
  @include topText();
  margin-top: 8px;
  margin-bottom: 24px;

  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
}

.srcMark {
  margin-bottom: 20px;
}

.bottomParent {
  margin-top: 24px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.closeButtonContainer {
  display: flex;
  justify-content: flex-end;
  padding: 21px 21px 0 0;
}

.cardList {
  padding-top: 12px;
  padding-left: 72px;
  padding-right: 38px;
  padding-bottom: 15px;
  margin-right: 34px;
  max-height: 195px;
  overflow-y: scroll;
  @include medium() {
    padding-left: 24px;
    padding-right: 14px;
    margin-right: 10px;
  }
}

.buttonDiv {
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;

  position: -webkit-sticky; /* Safari */
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 11;
  @include medium() {
    padding-left: 24px;
    padding-right: 24px;
  }
}

@mixin button() {
  width: 100%;
  max-width: 376px;
  height: 48px;
  display: flex;

  justify-content: center;
  align-items: center;

  cursor: pointer;
  border-radius: 24px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.addNewCardButton {
  @include button();
  margin-top: 16px;
  margin-bottom: 16px;

  background: #fcfcff;
  border: 2px solid #000000;
  color: #000000;
}

.cardListContinueButton {
  @include button();
  background: #16182b;
  color: #ffffff;
}

.cardListContinueButton:disabled {
  border: none;
  cursor: auto;
  background: #c5c5ca;
}

.listFadeDiv {
  position: relative;
  max-width: 580px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-left: 59px;
  margin-right: 44px;

  @include medium() {
    margin-left: 12px;
    margin-right: 16px;
  }
}

.listFade {
  width: 100%;
  position: absolute;
  height: 35px;
  bottom: 0px;
  z-index: 10;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 62.9%);
}

.infoText {
  position: relative;
  margin: 12px 72px 15px;

  @include medium() {
    width: calc(100% - 48px);
    max-width: 376px;
    margin: 12px auto 15px;
  }
}

/* width */
.cardList::-webkit-scrollbar {
  width: 4px;
}

/* Track */
.cardList::-webkit-scrollbar-track {
  background-color: transparent;
}

/* Handle */
.cardList::-webkit-scrollbar-thumb {
  background-color: #c5c5ca;
  border-radius: 4px;
}

.addCardIcon {
  width: 24px;
  margin-right: 7px;
}
